import { Chip } from "@mui/material";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { ImplementationStatus } from "generated-graphql/graphql";

function chipPropsForStatus(status: ImplementationStatus): {
  color?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
  variant?: "filled" | "outlined";
} {
  switch (status) {
    case ImplementationStatus.InProgress:
      return { color: "info", variant: "filled" };
    case ImplementationStatus.Blocked:
      return { color: "error", variant: "filled" };
    case ImplementationStatus.Complete:
      return { color: "success", variant: "filled" };
    case ImplementationStatus.NotApplicable:
      return { color: "default", variant: "outlined" };
    case ImplementationStatus.NotStarted:
    default:
      return { color: "default", variant: "filled" };
  }
}

export function ImplementationStatusChip({ status }: { status: ImplementationStatus }) {
  const { color, variant } = chipPropsForStatus(status);
  return (
    <Chip
      size="small"
      label={prettyPrintEnumValue(status, [], true)}
      color={color}
      variant={variant}
      sx={{ flexShrink: 0 }}
    />
  );
}
